import React, { useEffect, useState } from "react";
import { CSSTransition, TransitionGroup } from "react-transition-group";
// import "./NotificationSound.css";

interface NotificationProps {
  id: string;
  message: string;
  type: string;
  onClose: () => void;
  onApprove?: () => void;
  onReject?: () => void;
  count: number;
  total: number;
}

const NotificationSound: React.FC<NotificationProps> = ({
  message,
  onClose,
  type,
  onApprove,
  onReject,
  count,
  total,
}) => {
  const [audio] = useState(() => new Audio("/sound/alerta.mp3"));

  useEffect(() => {
    audio.loop = true;
    audio.play().catch((err) => console.error("Error playing alert sound:", err));

    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Enter" && type !== "ORDER_APPROVAL") {
        onClose();
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      audio.pause();
      audio.currentTime = 0; // Reset sound
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [audio, onClose, type]);

  return (
    <CSSTransition timeout={300} classNames="fade" appear in>
      <div
        style={{
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          background: "#333",
          color: "#fff",
          padding: "50px 20px",
          borderRadius: "5px",
          boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
          zIndex: 1000,
          textAlign: "center",
        }}
      >
        <div style={{ position: "absolute", top: "10px", right: "20px", fontSize: "20px", fontWeight: "bold" }}>
          {count}/{total}
        </div>

        <div
          dangerouslySetInnerHTML={{
            __html: message,
          }}
        ></div>
        
        {type === "ORDER_APPROVAL" ? (
          <div>
            <button
              onClick={onApprove}
              style={{
                background: "green",
                color: "#fff",
                border: "none",
                padding: "10px 20px",
                borderRadius: "3px",
                cursor: "pointer",
                margin: "5px",
                fontWeight: "bold"
              }}
            >
              ACEPTAR PEDIDO
            </button>
            <button
              onClick={onReject}
              style={{
                background: "red",
                color: "#fff",
                border: "none",
                padding: "10px 20px",
                borderRadius: "3px",
                cursor: "pointer",
                margin: "5px",
                fontWeight: "bold"
              }}
            >
              RECHAZAR PEDIDO
            </button>
          </div>
        ) : (
          <button
            onClick={onClose}
            style={{
              background: "red",
              color: "#fff",
              border: "none",
              padding: "10px 20px",
              borderRadius: "3px",
              cursor: "pointer",
              marginTop: "10px",
            }}
          >
            CERRAR
          </button>
        )}
      </div>
    </CSSTransition>
  );
};

export default NotificationSound;
